export const ALIGNMENT = {
    LEFT: "Left",
    RIGHT: "Right",
} as const;

export type ALIGNMENT = typeof ALIGNMENT[keyof typeof ALIGNMENT];
